import { createProvider } from '@nvision/services/data-provider';

import type { PortNameFilters } from '../../models';
import * as api from './api';
import { normalizePortNameFilters, normalizePortNames } from './normalize';

export const fetchPortNames = createProvider(
  (filters: Partial<PortNameFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchPortNames(normalizePortNameFilters(filters), { signal }),
).andThen((res) => normalizePortNames(res));
